import React from "react";
import "./SortableTableHeaderButton.css";

const SortableTableHeaderButton = ({ sortKey, activeSortKey, sortDir, onSort, children }) => (
  <button
    type="button"
    className={`sortable-table-header-button ${activeSortKey === sortKey ? "is-active" : ""}`}
    onClick={() => onSort(sortKey)}
  >
    {children}{" "}
    <span className="sortable-table-header-button-indicator">
      {activeSortKey !== sortKey ? "↕" : sortDir === "asc" ? "↑" : "↓"}
    </span>
  </button>
);

export default SortableTableHeaderButton;
